import { Component, inject } from '@angular/core';
import { ModalController } from '@ionic/angular/standalone';
import { TranslateModule } from '@ngx-translate/core';
import { MbmModalComponent } from '@modals';
import { MbmButtonComponent } from '@components';

@Component({
  selector: 'mbm-app-update-modal',
  imports: [TranslateModule, MbmModalComponent, MbmButtonComponent],
  templateUrl: './app-update-modal.component.html',
  styleUrl: './app-update-modal.component.scss',
})
export class AppUpdateModalComponent {
  private readonly modalController = inject(ModalController);

  protected onReload(): void {
    void this.modalController.dismiss(null, 'reload');
  }
}
